<su-headline h="h1" skin="primary"  [hidden]="filledForm">{{ headline }}</su-headline>

<su-card [card]="cardUser"  [hidden]="filledForm">
  <div card-content>
    <br />
    <formly-form [form]="form" [fields]="formFields" [model]="formModel">
    </formly-form>
  </div>
</su-card>

<su-headline *ngIf="filledForm" h="h1" skin="primary">{{
  'user.request.summary.title_create' | translate
}}</su-headline>
<div class="description" *ngIf="filledForm">
  <p
    [innerText]="'user.request.summary.p__info_summary' | translate"
    class="confirm-value"></p>
</div>
<br />
<su-card [card]="cardConfirm" *ngIf="filledForm">
  <div card-content data-debug="form-confirm">
    <ng-container>
      <div class="confirm-container">
        <div>
          <div class="confirm-label">
            <span>
              {{ 'user.request.summary.label__requestType' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['isTelekomChecked']">
              {{ 'administration.create_user.telekom_employee' | translate }}
            </span>
            <span class="confirm-value" *ngIf="!formModel['isTelekomChecked']">
              {{ 'administration.create_user.external_user' | translate }}
            </span>
          </div>
        </div>
        <div>
          <div class="confirm-label">
            <span>
              {{ 'administration.create_user.label__firstName' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['userData']['firstName']">
              {{ formModel['userData']['firstName']}}
            </span>
            <span class="confirm-value" *ngIf="!formModel['userData']['firstName']">
              --
            </span>
          </div>
        </div>
        <div>
          <div class="confirm-label">
            <span>
              {{ 'administration.create_user.label__lastName' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['userData']['lastName']">
              {{ formModel['userData']['lastName']}}
            </span>
            <span class="confirm-value" *ngIf="!formModel['userData']['lastName']">
              --
            </span>
          </div>
        </div>
        <div>
          <div class="confirm-label">
            <span>
              {{ 'administration.create_user.label__email' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['userData']['email']">
              {{ formModel['userData']['email']}}
            </span>
            <span class="confirm-value" *ngIf="!formModel['userData']['email']">
              --
            </span>
          </div>
        </div>
        <div *ngIf="!isTelekomChecked">
          <div class="confirm-label">
            <span>
              {{ 'user.request.create.label__organisation' | translate }}:
            </span>
          </div>
          <div>
            <span class="confirm-value" *ngIf="formModel['userData']['organisation']">
              <span *ngFor="let item of organisations$ | async | filterPipe : formModel['userData']['organisation'] : 'id'">
                {{ item.name }}
              </span>
            </span>
            <span class="confirm-value" *ngIf="!formModel['userData']['organisation']">
              --
            </span>
          </div>
        </div>
        <div>
          <div class="confirm-label">
            <span>
              {{ 'user.request.summary.label__requestedRoles' | translate }}:
            </span>
          </div>
          <div>
            <ul *ngIf="formModel['userData']['roles'].length > 0">
              <li class="confirm-value" *ngFor="let item of formModel['userData']['roles']">
                {{ item.description }}
              </li>
            </ul>
            <span class="confirm-value" *ngIf="formModel['userData']['roles'].length === 0">
              --
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <form (ngSubmit)="createUserRequest()">
      <div class="confirm-buttons">
        <su-button
          [skin]="'primary'"
          [icon]="'arrow-left'"
          [label]="'ticket.create.confirm.button__back_to_edit' | translate"
          (onClick)="discardSumUpForm()">
        </su-button>
        <su-button
          id="buttonSendInConfirmForm"
          type="submit"
          [skin]="'accent'"
          [icon]="'paper-plane'"
          [label]="'ticket.create.confirm.button__send' | translate"
          [disabled]="isSubmitted">
        </su-button>
      </div>
    </form>
  </div>
</su-card>

<app-spinner-overlay [show]="loading"></app-spinner-overlay>
